/* Publish by EComposer at 2024-06-06 15:06:17*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-e7ib7lrj7wv"]=  window.__ectimmers["ecom-e7ib7lrj7wv"] || {};
const e=this.$el;if(!e)return;let i=e.querySelector(".ecom-masonry-layout");if(!i)return;i.addEventListener("itemChange",function(){setTimeout(function(){i.masonry.layout()},500)});var t=i.getAttribute("data-ecom-packery-params")||"{}";let n=Object.assign({itemSelector:".ecom-masonry-layout__item",layoutMode:"masonry",percentPosition:!0,resize:!0},JSON.parse(t));var s=new window.EComPackery(i,n);i.masonry=s,i.querySelectorAll("img").forEach(function(o){o.addEventListener("load",function(){s.layout()})})

                    });
                    
                        document.querySelectorAll('.ecom-e7ib7lrj7wv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7ib7lrj7wv', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}